// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Jvoc","label":"styles_label__TdK9h"};